module.exports = __webpack_public_path__ + "static/media/René(1)-min.f43e56a2.jpg";